<template>
  <div class="siteHeader siteHeaderFixed safedigCustomHeader">
    <div class="siteInnerHeader siteInnerHeaderCentered siteInnerHeaderPadded">
      <h1 class="header">
        <router-link to="/home" class="headerTitleLink">
          <span>
            <img src="../../assets/safe-dig/safedig_logo_color-01.png" alt="Safe Dig Indiana" />
          </span>
        </router-link>
      </h1>

      <div class="d-flex align-items-center">
        <div>
          <ul class="headerLinkItems desktop topHeaderLinks">
            <li class="headerLinkItem ">
              <router-link to="/professionals" class="yellowHeaderLink">{{ $t('header.professional') }}</router-link>
              <span class="yellowHeaderLink">|</span>
            </li>
            <li class="headerLinkItem">
              <router-link to="/homeowners" class="yellowHeaderLink">{{ $t('header.homeowner') }}</router-link>
            </li>
          </ul>
          <ul class="headerLinkItems desktop bottomHeaderLinks">
            <li class="headerLinkItem">
              <router-link to="/info/contact_us" class="headerLink">{{ $t('header.about') }}</router-link>
            </li>
            <li class="headerLinkItem">
              <router-link to="/info/events" class="headerLink" active-class="active">{{ $t('header.events') }}</router-link>
            </li>
            <li class="headerLinkItem">
              <a href="#" class="headerLink" @click.prevent="handleTrainingClick">{{ $t('header.training') }}</a>
            </li>
            <li class="headerLinkItem">
              <router-link to="/info/grants" class="headerLink">{{ $t('header.grants') }}</router-link>
            </li>
            <li class="headerLinkItem" v-if="!isAuthenticated">
              <router-link to="/login" class="headerLink">{{ $t('header.logIn') }}</router-link>
            </li>
            <li class="headerLinkItem" v-if="!isAuthenticated">
              <router-link to="/register" class="headerLink">{{ $t('header.createAccount') }}</router-link>
            </li>
            <li class="headerLinkItem headerUserItem" v-else>
              <button
                class="headerLink userNameHeaderLink headerUserButton"
                type="button"
                @click="userMenuOpen = !userMenuOpen"
              >
                <span>{{ userName }}</span>
                <span class="headerUserCaret">▾</span>
              </button>
              <ul v-if="userMenuOpen" class="headerUserDropdown">
                <li>
                  <router-link
                    to="/dashboard"
                    class="headerLink"
                    @click.native="userMenuOpen = false"
                  >{{ $t('header.dashboard') }}</router-link>
                </li>
                <li>
                  <a href="#" class="headerLink" @click.prevent="handleLogout">Logout</a>
                </li>
              </ul>
            </li>
            <li class="headerLinkItem headerLinkItemLang">
              <a href="#" class="headerLink userNameHeaderLink" @click.prevent="toggleLocale">
                <span class="flex items-center lang-oneline">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                    stroke="currentColor" class="lang-globe-icon">
                    <path stroke-linecap="round" stroke-linejoin="round"
                      d="M12 21a9.004 9.004 0 0 0 8.716-6.747M12 21a9.004 9.004 0 0 1-8.716-6.747M12 21c2.485 0 4.5-4.03 4.5-9S14.485 3 12 3m0 18c-2.485 0-4.5-4.03-4.5-9S9.515 3 12 3m0 0a8.997 8.997 0 0 1 7.843 4.582M12 3a8.997 8.997 0 0 0-7.843 4.582m15.686 0A11.953 11.953 0 0 1 12 10.5c-2.998 0-5.74-1.1-7.843-2.918m15.686 0A8.959 8.959 0 0 1 21 12c0 .778-.099 1.533-.284 2.253m0 0A17.919 17.919 0 0 1 12 16.5c-3.162 0-6.133-.815-8.716-2.247m0 0A9.015 9.015 0 0 1 3 12c0-1.605.42-3.113 1.157-4.418">
                    </path>
                  </svg>
                  <span class="lang-text">{{ $t('header.enEspanol') }}</span>
                </span>
              </a>
            </li>
          </ul>
        </div>

        <div class="mobile">
          <ul class="headerLinkItems mobile">
            <li class="headerLinkItem">
              <a href="#" class="headerLink headerLinkNoHover" aria-label="Toggle menu"
                @click.prevent="mobileMenuOpen = !mobileMenuOpen">
                <div class="menuIcon">
                  <div class="bar"></div>
                  <div class="bar"></div>
                  <div class="bar"></div>
                </div>
              </a>
            </li>
          </ul>
        </div>
      </div>

      <ul class="mobileHeaderLinkItems headerLinkItems" :style="{ display: mobileMenuOpen ? 'flex' : 'none' }">
        <li class="headerLinkItem">
          <router-link to="/info/contact_us" class="headerLink" @click.native="mobileMenuOpen = false">{{
            $t('header.about') }}</router-link>
        </li>
        <li class="headerLinkItem">
          <router-link to="/info/events" class="headerLink" active-class="active" @click.native="mobileMenuOpen = false">{{
            $t('header.events') }}</router-link>
        </li>
        <li class="headerLinkItem">
          <a href="#" class="headerLink" @click.prevent="handleTrainingClick">{{ $t('header.training') }}</a>
        </li>
        <li class="headerLinkItem">
          <router-link to="/info/grants" class="headerLink" @click.native="mobileMenuOpen = false">{{
            $t('header.grants') }}</router-link>
        </li>
        <li class="headerLinkItem" v-if="!isAuthenticated">
          <router-link to="/login" class="headerLink" @click.native="mobileMenuOpen = false">{{
            $t('header.logIn') }}</router-link>
        </li>
        <li class="headerLinkItem" v-if="!isAuthenticated">
          <router-link to="/register" class="headerLink" @click.native="mobileMenuOpen = false">{{
            $t('header.createAccount') }}</router-link>
        </li>
        <li class="headerLinkItem" v-else>
          <button
            class="headerLink headerLinkNoHover headerUserButton"
            type="button"
            @click="userMenuOpen = !userMenuOpen"
          >
            <span>{{ userName }}</span>
            <span class="headerUserCaret">▾</span>
          </button>
          <ul v-if="userMenuOpen" class="headerUserDropdown mobileDropdown">
            <li>
              <router-link
                to="/dashboard"
                class="headerLink"
                @click.native="userMenuOpen = false; mobileMenuOpen = false"
              >{{ $t('header.dashboard') }}</router-link>
            </li>
            <li>
              <a href="#" class="headerLink" @click.prevent="handleLogout">Logout</a>
            </li>
          </ul>
        </li>
        <li class="headerLinkItem">
          <a href="/professionals" class="headerLink yellowLink">{{ $t('header.professional') }}</a>
        </li>
        <li class="headerLinkItem">
          <a href="/homeowners" class="headerLink yellowLink">{{ $t('header.homeowner') }}</a>
        </li>
        <li class="headerLinkItem">
          <a href="#" class="headerLink" @click.prevent="toggleLocale">{{ $t('header.enEspanol') }}</a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { getSavedLocale, setSavedLocale } from '@/i18n';
import { recordServerLogoutThenClearHotSession } from '@/utils/hotSessionClear';

export default {
  name: 'SafeDigHeader',
  data() {
    return {
      mobileMenuOpen: false,
      isAuthenticated: false,
      userName: '',
      userMenuOpen: false
    };
  },
  methods: {
    handleTrainingClick() {
      const token = localStorage.getItem('hot-token');
      this.mobileMenuOpen = false;
      if (token) {
        this.$router.push('/dashboard');
      } else {
        this.$router.push('/login');
      }
    },
    handleLogout() {
      this.mobileMenuOpen = false;
      this.userMenuOpen = false;
      // Avoid pushing `/safe-dig-indiana` + guard redirect: Vue Router 3 rejects that promise with NavigationRedirected.
      recordServerLogoutThenClearHotSession().then(() => {
        this.isAuthenticated = false;
        this.userName = '';
        this.mobileMenuOpen = false;
        if (this.$route.path !== '/home') {
          this.$router.replace('/home').catch(() => {});
        }
      });
    },
    toggleLocale() {
      this.mobileMenuOpen = false;
      const nextLocale = this.$i18n.locale === 'en' ? 'es' : 'en';
      this.$i18n.locale = nextLocale;
      setSavedLocale(nextLocale);
    }
  },
  created() {
    const token = localStorage.getItem('hot-token');
    this.isAuthenticated = !!token;
    if (this.isAuthenticated) {
      this.userName =
        localStorage.getItem('hot-user-full-name') ||
        localStorage.getItem('hot-user-name') ||
        localStorage.getItem('hot-email') ||
        '';
    }
    const saved = getSavedLocale();
    if (saved && this.$i18n.availableLocales.includes(saved)) {
      this.$i18n.locale = saved;
    }
  }
};
</script>

<style scoped>
.siteHeader {
  font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
  background: #fff;
  border-bottom: 1px solid #2f5b75;
  position: relative;
  z-index: 100;
}

.siteHeaderFixed {
  position: sticky;
  top: 0;
}

.siteInnerHeader {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
}

.siteInnerHeaderCentered {
  max-width: 1200px;
  margin: 0 auto;
}

.siteInnerHeaderPadded {
  padding: 0.75rem 1.5rem;
}

.siteInnerHeader .header {
  margin: 0;
  font-size: inherit;
  font-weight: inherit;
}

.headerTitleLink {
  display: inline-block;
  text-decoration: none;
  color: inherit;
}

.headerTitleLink img {
  height: 75px;
}

.d-flex {
  display: flex;
}

.align-items-center {
  align-items: center;
}

.headerLinkItems {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}

.headerLinkItems.desktop {
  display: none;
}

.safedigCustomHeader .topHeaderLinks {
  justify-content: right;
  height: 26px;
}

.safedigCustomHeader .topHeaderLinks .headerLinkItem {
  margin-left: 0.25rem;
}

.safedigCustomHeader .topHeaderLinks .headerLinkItem .yellowHeaderLink {
  color: #edcd00;
  text-decoration: none;
  font-size: 10px;
  font-weight: 500;
  text-transform: uppercase;
  padding: 0 5px;
}

.headerLink {
  color: #2d4b6c;
  text-decoration: none;
  font-size:15px;
  font-weight: 500;
  padding: 12px 15px;
}

.headerLink:hover {
  text-decoration: underline;
}

a.headerLink.active {
  background: #869eb8;
  padding: 12px 15px;
}

a.yellowHeaderLink:hover {
  text-decoration: underline;
}

.userNameHeaderLink {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
}

.headerUserItem {
  position: relative;
}

.headerUserButton {
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 12px 15px;
}

.headerUserButton:focus {
  outline: none;
}

.headerUserCaret {
  font-size: 10px;
}

.headerUserDropdown {
  position: absolute;
  right: 18px;
  top: 36px;
  background: #fff;
  border: 1px solid #d1d5db;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.08);
  list-style: none;
  margin: 0;
  padding: 4px 0;
  min-width: 140px;
  z-index: 200;
}

.headerUserDropdown li {
  width: 100%;
}

.headerUserDropdown .headerLink {
  display: block;
  width: 100%;
  padding: 8px 16px;
}

.headerUserDropdown .headerLink:hover {
  background-color: #f3f4f6;
  text-decoration: none;
}

.flex.items-center {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
}

.lang-globe-icon {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
}

.headerLinkItemLang .lang-oneline {
  white-space: nowrap;
  flex-direction: row;
}

.mobile {
  display: block;
}

.headerLinkNoHover:hover {
  text-decoration: none;
}

.menuIcon {
  display: flex;
  flex-direction: column;
  gap: 5px;
  padding: 4px;
}

.menuIcon .bar {
  width: 22px;
  height: 2px;
  background: #1e3a5f;
  border-radius: 1px;
}

.mobileHeaderLinkItems {
  flex-basis: 100%;
  flex-direction: column;
  padding: 10px 0 0;
  border-top: 1px solid #eee;
  margin-top: 5px;
  gap: 5px;
}

.mobileHeaderLinkItems .headerLinkItem {
  width: 100%;
}

.mobileHeaderLinkItems .headerLink,
.mobileHeaderLinkItems .yellowLink {
  display: block;
  padding: 0.5rem 0;
}

.mobileHeaderLinkItems .yellowLink {
  color: #c99400;
  font-weight: 600;
}

.mobileDropdown {
  position: static;
  border: none;
  box-shadow: none;
}


@media (min-width: 992px) {
  .headerLinkItems.desktop {
    display: flex;
  }
  .bottomHeaderLinks{
    height: 50px;
  }

  .mobile {
    display: none;
  }
}
</style>
